<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :fulfillment-modules="fulfillmentModules"
            :account-tags="accountTags"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/FulfillmentAccountGroups/Form'

export default {
    name: 'FulfillmentAccountGroupCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        fulfillmentModules: {
            type: Array,
            default () {
                return []
            }
        },
        accountTags: {
            type: Array,
            default () {
                return []
            }
        },
    },
    methods: {
        submitData (form) {
            form.post(this.$route('products.account-groups.store'))
        }
    }
}
</script>
